import { forwardRef, type Ref, type SVGProps } from "react";
const IconSortOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M22.83 4a1 1 0 0 0-2 0v21.41L15.73 20a1 1 0 0 0-1.41-.06 1 1 0 0 0-.05 1.42l6.85 7.32a1 1 0 0 0 1.47 0L29.73 21a1 1 0 0 0-1.46-1.36l-5.44 5.83z"
    />
    <path
      fill="currentColor"
      d="M9.17 28a1 1 0 0 0 2 0V6.59l5.1 5.41a1 1 0 0 0 1.41.06 1 1 0 0 0 .05-1.42l-6.85-7.32a1 1 0 0 0-1.47 0L2.27 11a1 1 0 1 0 1.46 1.36l5.44-5.83z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSortOutlineSVG);
ForwardRef.displayName = "IconSortOutline";
export { ForwardRef as IconSortOutline };
